import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VeeValidate from 'vee-validate';
import { lsErrorService, lsValidationService } from 'ls-vue-common';
// need to add some type of new library or initialization logic? well hold your 🐎🐎 just a minute.
// we want to go ahead and do that in the /init.js file imported below so we don't have to duplicate.
import './init';

import App from './App.vue';
import router from './router';
import store from './store';
import { createProvider } from './vue-apollo';
import { lsScreenSizeMixin } from '@/mixins';

Sentry.init({
    dsn: 'https://14975cc55b954a06935dfea109d404db@sentry.io/1860375',
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    environment: process.env.VUE_APP_ENVIRONMENT,
    release: process.env.VUE_APP_VERSION,
});

// https://github.com/vuejs/vue/issues/8433
// Vue internally will not call logError due to a currently know limitation
// We need to manually send errors to Sentry so we can also still show them in the console
Vue.config.errorHandler = function(error) {
    if (error) {
        lsErrorService.log({ error });
    }
};

Vue.config.productionTip = false;
Vue.use(VeeValidate, { inject: false });

lsValidationService.extendVeeValidate();

const apolloProvider = createProvider();

new Vue({
    router,
    store,
    apolloProvider,
    mixins: [lsScreenSizeMixin],
    render: (h) => h(App),
}).$mount('#app');
